<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/13LG3rN/tc-custom/9798889101246.jpg?1705056298016" alt="This image is the cover for the book The Mavericus: Mission Unspecified"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Mavericus: Mission Unspecified
      </h1>
      <p class="bookDescription body article font2">
        <p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;font-size:15px;font-family:"Calibri",sans-serif;'><span style='font-size:16px;font-family:"Charis SIL";'>The year is 2331 and there is instability among the human colonies that are spread out across a region of the known galaxy. John Raylor, a by-the-book officer in the Space Security Force, attempts to leave the military in hopes of returning to his son on Earth only to be brought back on one last mission. The mission brings John to the Starship Mavericus with vague details coming from a secret organization within the Federated Nations, the government apparatus for the far-off human space colonies.</span></p><p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;font-size:15px;font-family:"Calibri",sans-serif;'><span style='font-size:16px;font-family:"Charis SIL";'>After debarking from Earth, John discovers two unexpected stowaways aboard the military vessel headed towards an unstable breakaway colony. John finds himself torn between his duty as second-in-command of the ship and everything else aboard the Starship Mavericus. This unexpected mission sets the stage for tragedy and for John Raylor to become the controversial captain on his own personal quest that would change the Federated Nations.</span></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        S.C. Aaron
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a149d02e